import { borderStyles, borderWidths } from './borders.js';
import { colors } from './colors.js';
import { radii } from './radius.js';
export const outlines = {
    none: 'none',
    common: {
        borderRadius: radii.x1_5,
    },
    item: {
        rule: `${borderWidths.md} ${borderStyles.solid} ${colors.outlines.default}`,
        offset: '-2px',
    },
    control: {
        rule: `${borderWidths.md} ${borderStyles.solid} ${colors.outlines.default}`,
        offset: '2px',
    },
    input: {
        rule: `${borderWidths.sm} ${borderStyles.solid} ${colors.outlines.input}`,
        offset: '-1px',
    },
    link: {
        rule: `${borderWidths.md} ${borderStyles.solid} ${colors.outlines.default}`,
        offset: '2px',
        borderRadius: radii.x_5,
    },
    tab: {
        rule: `${borderWidths.md} ${borderStyles.solid} ${colors.outlines.default}`,
        offset: '-2px',
    },
};
//# sourceMappingURL=outlines.js.map